import React, { Component } from "react";

class section1 extends Component {
  render() {
    return (
      <div className="section1 text-light row">
        <div className="content col-sm-12 col-md-12 col-lg-8 col-12">
          <h1 className="heading12">
            Meet the <span className="span1">culture</span> that will inspire
            you
          </h1>
          <p className="p12a">
            Don't just live, live a Full life--live your Best life.
          </p>
          <p className="p12b">
            These Products are an extension of your passion.
          </p>
          <div className="pl-5 pb-5 ">
            <button className="btn button12 text-light">LEARN MORE</button>
          </div>
        </div>
      </div>
    );
  }
}

export default section1;
